let listenerTypesRegistered = [];
  const styles = `.csm-cookie-consent {
    visibility: hidden;
  }`;
  const hideCCStylsheet = document.createElement("style");
  hideCCStylsheet.textContent = styles;
  document.head.appendChild(hideCCStylsheet);
  const showCookieBar = () => {
      document.querySelector('.csm-cookie-consent').style.visibility='visible';
      listenerTypesRegistered.forEach(function(typeRegistered){
        window.removeEventListener(typeRegistered, showCookieBar, false);
      });
    }
  ['keypress', 'click', 'scroll'].forEach(function(e){
    listenerTypesRegistered.push(e);
    window.addEventListener(e,showCookieBar,false);
  });